import { useState } from "react";
import i18n from "../../lib/i18n";

export default function NotificationDialog ({loadingSend, handleSend, closeSendNotification, username}) {

    const t = i18n.t.bind(i18n); 
    const [title, setTitle] = useState(null);
    const [description, setDescription] = useState(null);

    const onChangeTitle = (title) => {
        setTitle(title);
    };

    const onChangeDescription = (description) => {
        setDescription(description);
    };

        return(
                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">  
                    <div className="bg-furthly py-6 px-10 rounded-md shadow-lg">  
                        <h2 className="text-[20px] text-center text-white font-semibold mb-3">{t("user.confirm_send")}</h2>  
                        <p className="mb-3 text-white text-md">{t("user.send_notification")} {username}</p>  
                        <div>
                            <input
                                type="text"
                                value={title}
                                onChange={(e)=> onChangeTitle(e.target.value)}
                                placeholder={t("user.enter_title")}
                                className="w-full bg-thirdly mb-3 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <input
                                type="text"
                                value={description}
                                onChange={(e)=> onChangeDescription(e.target.value)}
                                placeholder={t("user.enter_description")}
                                className="w-full bg-thirdly mb-5 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                        </div>
                        <div className="flex justify-between">  
                            <button  
                                type="button"
                                onClick={closeSendNotification}  
                                className="mr-2 bg-white hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded"  
                            >  
                                {t("user.cancel")}
                            </button>  
                            <button  
                                onClick={() => handleSend(title, description)}  
                                disabled={loadingSend}
                                className="bg-green-700 hover:bg-green-600 text-white font-bold py-2 px-4 rounded"  
                            >  
                            {loadingSend
                                ?   <div className="animate-spin border-4 border-white border-t-transparent rounded-full w-6 h-6"></div>
                                :   t("user.send")
                            }     
                            </button> 
                        </div>  
                    </div>  
                </div>  
        );
};